import { CIcon } from '~/icons/types'
export const ciInfo: CIcon = {
  width: 512,
  height: 512,
  paths: [
    {
      d:
        'M356.2 512H166.8c-6.1 0-11-4.9-11-11v-12.8c0-6 4.7-10.8 10.7-11 10.3-.4 17.8-2.7 22.9-7.3 1.4-1.3 2.4-2.9 2.9-4.7 1.3-4.1 3-13.3 3-32.7V239.8c0-29.4-4.6-36.4-5.5-37.5-1.9-2.3-7.5-6.2-23.6-7.2-5.8-.3-10.4-5.2-10.4-11v-13.2c0-6.1 4.9-11 11-11h138.5c6.1 0 11 4.9 11 11v261.6c0 29.4 4.6 36.4 5.5 37.5 1.9 2.3 7.5 6.2 23.9 7.2 5.8.3 10.4 5.2 10.4 11V512h.1zM255.8 131.2c-18 0-33.6-6.4-46.3-19.1-12.7-12.7-19.1-28.3-19.1-46.3s6.4-33.6 19.1-46.4C222.2 6.5 237.8 0 255.8 0c18.3 0 34 6.5 46.7 19.3s19.1 28.4 19.1 46.4c0 18.1-6.5 33.6-19.3 46.3-12.9 12.8-28.5 19.2-46.5 19.2z'
    }
  ],
  name: 'info',
  type: 'solid'
}
